export default "__VITE_ASSET__Crw3TCUA__"